__turbopack_context__.v({
  "container": "styles-module-scss-module__N60GYG__container",
  "heroContainer": "styles-module-scss-module__N60GYG__heroContainer",
  "imageSlot": "styles-module-scss-module__N60GYG__imageSlot",
});
